import { system } from 'styled-system';
const config = {
  cursor: {
    property: 'cursor',
    scale: 'cursor'
  }
};
export const cursor = system(config);